export default __webpack_public_path__ + "locales/uk-UA/ChangePortalOwner.json?hash=8bbbdd731de9b914c5de2c606b074824";